// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 66) return "static/chunks/66-2cca5e18fb278100.js";
	if (chunkId === 545) return "static/chunks/545-e37710afe898d446.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"35":"6f6db0439b10fea6","164":"a48bd21688727eab","383":"2bba960faf9632c1"}[chunkId] + ".js";
};